import styled from 'styled-components';

export const DetailWrapper = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sm};
  align-items: flex-start;
`;

export const DetailIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding-top: 2px;
`;

export const DetailContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.xxs};
`;

export const DetailLabel = styled.span`
  font-size: ${props => props.theme.typography.sizes.xs};
  font-weight: ${props => props.theme.typography.weights.semibold};
  color: ${props => props.theme.colors.textSecondary};
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

export const DetailValue = styled.div`
  font-size: ${props => props.theme.typography.sizes.sm};
  line-height: ${props => props.theme.typography.lineHeights.sm};
  color: ${props => props.theme.colors.textPrimary};
`;
